<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import { trans as $t } from 'laravel-vue-i18n';

export default {
    components: {
        VueTelInput,
    },
    props: {
        id: {
            type: String,
            required: true
        },
        class: {
            type: String
        },
        placeholder: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: String
        },
    },
    data() {
        return {
            initialChange: true,
            phone: '',
            inputOptions: {
                id: '',
                placeholder: ' ',
                styleClasses: '',
                maxlength: 25,
                readonly: false
            },
            dropdownOptions: {
                disabled: false,
                showFlags: true,
                showDialCodeInSelection: false,
                showSearchBox: true
            }
        }
    },
    methods: {
        inputOpened(countryObject) {
            setTimeout(() => {
                const el = this.$el.querySelector('.vti__search_box');
                if (el) {
                    el.placeholder = $t('Keresés...');
                    el.focus();
                }
            }, 10);
        },
        countryChanged(countryObject) {

            if (this.initialChange) {
                this.initialChange = false;
                return;
            }

            // this.$emit('update:modelValue', '+' + countryObject.dialCode);
            this.phone = '+' + countryObject.dialCode;
        },
    },
    watch: {
        phone: {
            handler(newValue, oldValue) {
                this.$emit('update:modelValue', newValue?.replace(/\s+/g, ''));
            },
        },
    },
    emits: [
        'update:modelValue'
    ],
    mounted() {
        // console.log('Phone input mounted');
        this.inputOptions.id = this.id;
        this.inputOptions.placeholder = this.placeholder;
        this.inputOptions.readonly = this.readonly;
        this.dropdownOptions.disabled = this.readonly;
        // this.inputOptions.styleClasses = this.class;
        if (!this.modelValue) {
            this.phone = '+36';
        } else {
            this.phone = this.modelValue;
        }
    }
}
</script>

<style>
.vue-tel-input.form-control {
    padding-top: 1.3rem !important;
    padding-bottom: .3rem !important;
}

.vue-tel-input:focus,
.vue-tel-input:focus-within {
    color: #212436;
    background-color: transparent;
    border-color: #d90134;
    outline: 0;
    box-shadow: none;
}

.vti__dropdown {
    padding: 0;
}

.vti__dropdown-item>strong {
    font-size: .8em;
    font-weight: normal;
}

.vti__input {
    font-weight: 700;
}

.vti__dropdown-list {
    z-index: 100;
}
</style>

<template>
    <vue-tel-input v-model="phone" maxlength="20" :class="class" :disabled="disabled" mode="international" :autoDefaultCountry="false" defaultCountry="HU" :inputOptions="inputOptions" :dropdownOptions="dropdownOptions"
        @open="inputOpened" @country-changed="countryChanged" ref="telInput"></vue-tel-input>
</template>
